import { Component } from '@angular/core';
import { DynamicDialogRef } from 'primeng/dynamicdialog';

@Component({
  selector: 'app-stripe-slot-update-popup',
  templateUrl: './stripe-slot-update-popup.component.html',
  styleUrls: ['./stripe-slot-update-popup.component.scss']
})
export class StripeSlotUpdatePopupComponent {
  constructor(
    private readonly ref: DynamicDialogRef,

  ) { }

  closePopup() {
    this.ref.close();
  }
}
